import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import QueryParameters from "../api/QueryParameters";
import { getPreferences } from "../api/requests";
import { Preferences, PreferencesOption } from "../common/GeneralClasses";
import { removeParam } from "../common/QueryParamsUtil";
import ErrorMessage from "../components/ErrorMessage";
import PreferenceButton from "../components/PreferencesButton";
import Spinner from "../components/Spinner";
import { CommunicationsHubLabels } from "../labels/CommunicationsHubLabels";
import { CommunicationsHubLabelsMapper } from "../mappers/labels/CommunicationsHubLabelsMapper";
import { PreferencesMapper } from "../mappers/PreferencesMapper";
import "./CommunicationsHub.css";

export default function CommunicationsHub() {
  const [labels, setLabels] = useState<CommunicationsHubLabels>({} as CommunicationsHubLabels);
  const [preferences, setPreferences] = useState<Preferences[]>([]);
  const [options, setOptions] = useState<PreferencesOption[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const location = useLocation();
  const history = useHistory();

  const SCR_PARAM = "scr";
  const UNSUBSCRIBE_LINK_PLACEHOLDER = "ph_unsubscribe_link_ph";

  useEffect(() => {
    setLoading(true);
    const queryParams = new QueryParameters();
    getPreferences(queryParams).then((data) => {
      setOptions(data.preferences);
      const preferencesMapper = new PreferencesMapper();
      setPreferences(preferencesMapper.get(data.preferences));
      const communicationsHubLabelsMapper = new CommunicationsHubLabelsMapper();
      const modifiedQueryParams = removeParam(location.search, SCR_PARAM);
      let modifiedLabels = communicationsHubLabelsMapper.replacePlaceholder(
        data.labels,
        history.location.pathname + "?" + modifiedQueryParams,
        UNSUBSCRIBE_LINK_PLACEHOLDER
      );
      setLabels(communicationsHubLabelsMapper.get(modifiedLabels));
      setError(data.error);
      setLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handlePreferenceChange(event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.target.value;
    const checked = event.target.checked;

    setPreferences((prevState) =>
      prevState.map((item) => {
        if (item.id === value) {
          return new Preferences(value, checked);
        }
        return item;
      })
    );
  }

  if (loading) {
    return (
      <div className="center">
        <Spinner isLoading={true} />
      </div>
    );
  }

  return (
    <div className="communications-hub">
      <h1>{labels.title.value}</h1>
      <div className="subtitle">
        <p>{labels.subtitle.value}</p>
      </div>
      <div className="statement">
        <p>{labels.statement.value}</p>
      </div>
      {error ? <ErrorMessage errorMessage={labels.error.value} /> : ""}
      <div className="checkboxes">
        {options.map((preference) => (
          <div key={preference.id}>
            <label className="checkbox-label" htmlFor={preference.id}>
              <input
                type="checkbox"
                id={preference.id}
                value={preference.id}
                onChange={handlePreferenceChange}
                defaultChecked={preference.value}
              />
              {preference.label}
            </label>
          </div>
        ))}
      </div>
      <div className="divider"></div>
      <div className="unsibscribe-link">
        <p dangerouslySetInnerHTML={{ __html: labels.unsubscribeLink.value }} />
      </div>
      <PreferenceButton
        buttonLabel={labels.saveChangesButtonLabel.value}
        thankYouLabel={labels.thankYou.value}
        errorMessage={labels.error.value}
        confirmButtonLabel={labels.okButtonLabel.value}
        confirmButtonUrl={labels.brandHomepageUrl.value}
        preferences={preferences}
      />
    </div>
  );
}
